var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHk = function SvgIconHk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.239 9.078c-.273 1.134-.758.918-.995 1.907a2.609 2.609 0 0 1 1.22-5.073c-.476 1.978.019 2.151-.225 3.166M9.604 9.918c.995.61.639 1.004 1.506 1.536a2.609 2.609 0 0 1-4.447-2.728c1.734 1.064 2.051.646 2.94 1.192M9.28 13.635c.887-.757 1.152-.297 1.926-.958a2.609 2.609 0 1 1-3.969 3.387c1.548-1.32 1.249-1.752 2.042-2.429M12.715 15.092c-.447-1.078.072-1.188-.317-2.128a2.609 2.609 0 0 1 1.996 4.82c-.778-1.88-1.28-1.728-1.68-2.692M15.162 12.274c-1.163.091-1.107-.436-2.122-.357a2.61 2.61 0 0 1 5.202-.408c-2.029.16-2.04.684-3.08.765"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconHk;